import { createSlice } from '@reduxjs/toolkit'
import Config from '../../Core/Config'

const configuratorUiSlice = createSlice({
  name: 'configurator',
  initialState: {
    menu: {
      expanded: Config.ui.defaultExpandedRightMenu,
    },
  },
  reducers: {
    toggleMenuExpanded: (state) => {
      state.menu.expanded = !state.menu.expanded
    },
  },
})

export const { toggleMenuExpanded } = configuratorUiSlice.actions
export default configuratorUiSlice.reducer

export const selectMenuExpanded = (state) => state.ui.configurator.menu.expanded
